import React, { ReactNode } from 'react';
import { SideNavLayoutComponent } from './SideNavLayoutComponent';
import useIsLoggedIn from '../../../../hooks/useIsLoggedIn';
import useIsOnBoardingRoute from '../../../../hooks/useIsOnBoardingRoute';
import { useDeviceDetection } from '../../../../hooks/useDeviceDetection';

export const SideNavLayoutContainer: React.FC<{
	children: ReactNode;
	hideSideNav?: boolean;
}> = ( { children, hideSideNav } ) => {
	const isLoggedIn = useIsLoggedIn();
	const { isDesktop } = useDeviceDetection();
	const isOnBoardingRoute = useIsOnBoardingRoute();

	const isShowingSideNav =
		isLoggedIn && isDesktop && !isOnBoardingRoute && !hideSideNav;

	return (
		<SideNavLayoutComponent isShowingSideNav={ isShowingSideNav }>
			{ children }
		</SideNavLayoutComponent>
	);
};
